import React from 'react';
import PropTypes from 'prop-types';

const Button = props => {

    const { classButton, text, url } = props;

    return (
        <a 
            className={`d-inline-block mt-3 rounded-custom py-2 px-3 px-md-4 ${classButton}`}
            href={url}
        >
            {text}
        </a>
    )
}

export default Button;

Button.propTypes = {    
    classButton: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
}
